"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_final_form_1 = require("react-final-form");
var ButtonPrimary_1 = __importDefault(require("atomicComponents/atoms/Buttons/ButtonPrimary"));
var FieldCheckbox_1 = __importDefault(require("components/Form/FieldCheckbox"));
var FieldText_1 = __importDefault(require("components/Form/FieldText"));
var validators_1 = require("utils/form/validators");
var DebugQueries = function (_a) {
    var testSalesforce = _a.testSalesforce;
    return ((0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: function (_a) {
            var all = _a.all, values = __rest(_a, ["all"]);
            return testSalesforce({ query: (0, end2end_1.getSoql)(values), all: all });
        }, validate: function (fV) { return (0, validators_1.requiredFields)(['from', 'fields'])(__assign({}, fV)); } }, { children: function (_a) {
            var handleSubmit = _a.handleSubmit, values = _a.values, invalid = _a.invalid, errors = _a.errors;
            return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "fields", label: "SELECT ", placeholder: "SELECT " }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "from", label: "FROM " }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "where", label: "WHERE " }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "groupBy" }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "orderBy" }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "limit" }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "offset" }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "extra" }), (0, jsx_runtime_1.jsx)(FieldCheckbox_1.default, { name: "all" }), (0, jsx_runtime_1.jsxs)("div", { children: ["Query:", (0, jsx_runtime_1.jsx)("pre", { children: !invalid ? (0, end2end_1.getSoql)(values) : "Missing ".concat(Object.keys(errors)) })] }), (0, jsx_runtime_1.jsx)(ButtonPrimary_1.default, __assign({ type: "submit" }, { children: "submit" }))] })));
        } })));
};
exports.default = DebugQueries;
